module.exports = __webpack_public_path__ + "img/ireen-logo.e93e319.svg";